import { Types } from './types'
const initialState = {
    dataVideo: {
        rows: [],
        paging: {}
    },
    dataVideoHomepage: {
        rows: [],
        paging: {}
    }
}

const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_VIDEO:
            return {
                ...newState,
                dataVideo: action.payload
            }
        case Types.SAVE_LIST_VIDEO_HOMEPAGE:
            return {
                ...newState,
                dataVideoHomepage: action.payload
            }
        default:
            return newState
    }
}

export default reducer